"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      borderRadius: 3,
      cursor: 'pointer',
      display: 'flex',
      height: 32,
      '&:hover $filterLabel': {
        color: theme.palette.NEUTRAL700
      }
    },
    rootActive: {
      '& $filterButton': {
        backgroundColor: theme.palette.NEUTRAL020,
        borderRadius: '3px 0 0 3px'
      },
      '& $filterClose': {
        display: 'flex'
      },
      '& $filterLabel': {
        color: theme.palette.NEUTRAL700
      }
    },
    rootSmall: {
      '& $filterButton': {
        padding: theme.spacing(0.5, 1),
        paddingRight: theme.spacing(0.25)
      },
      '& $filterClose': {
        height: 32
      }
    },
    filterButton: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(17),
      color: theme.palette.NEUTRAL700,
      padding: theme.spacing(0.75, 1),
      paddingRight: theme.spacing(0.25),
      borderRadius: 3,
      '&:hover': {
        backgroundColor: theme.palette.NEUTRAL030
      },
      '&:focus': {
        backgroundColor: theme.palette.NEUTRAL030,
        outline: 'none'
      }
    },
    filterLabel: {
      marginRight: theme.spacing(0.5),
      color: theme.palette.NEUTRAL600
    },
    filterValue: {},
    filterClose: {
      display: 'none',
      backgroundColor: theme.palette.NEUTRAL040,
      alignItems: 'center',
      borderRadius: '0 3px 3px 0',
      height: 36,
      width: 28,
      minWidth: 28,
      justifyContent: 'center',
      outline: 'none',
      '&:hover': {
        backgroundColor: theme.palette.NEUTRAL050
      }
    }
  };
});
var _default = useStyles;
exports.default = _default;